import compileSymbols from '~/utils/compileSymbols';
const types = [
  'DESELECT_ALL_ICONS',
  'DESELECT_ICON',
  'SELECT_ICON',
  'SELECT_ICONS',
  'SELECT_ADDITIONAL_ICONS'
];
export default compileSymbols(types, 'selection');
